<style>

h3{
  text-align: center;
}

.space{
  margin: 20px;
}

</style>

<Auth bind:this="{auth}"></Auth>
<Profile bind:this="{profile}" bind:me="{me}"></Profile>

{#if show}

<h3>What's your phone number?</h3>
<div class="space">
  <ValidInput bind:value="{phone}" valid="{valid}" theme="light" on:changed="{check}"></ValidInput>
</div>
<div class="space small">We'll send you a text message with a code to verify your phone number.</div>

{/if}



<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

import Auth from "../../interfaces/Auth.svelte";
let auth;

import Profile from "../../interfaces/Profile.svelte";
let profile;

import Validate from "../../helpers/Validate.js";
import Normalize from "../../helpers/Normalize.js";

import ValidInput from "../../components/ValidInput.svelte";

import UnitedStates from "../../addresses/UnitedStates.js";

export let show = false;
export let me = null;

let phone = "";
let valid = true;
let signupDelayHandle = null;
let lastPhone = "";

$:{
  if (me) set();
}


function set() {
  phone = UnitedStates.phone(me.phone);
}


function check(e) {
  clearTimeout(signupDelayHandle);
  
  if (phone == lastPhone) return;
  
  signupDelayHandle = setTimeout( async () => {
    lastPhone = phone;
    try {
      Validate.phone(phone);
      valid = true;
    } catch (e) {
      valid = false;
      console.log("error:", e);
    }
  }, 450);
  
}


export const save = async () => {
  if (phone != me.phone) {
    phone = Normalize.phone(phone);
    me.phone = phone;
    await profile.updateMe( { updateShare: true } );
    let res = await auth.post("savePhone", {phone: phone});
    if (res == "+") {
      // enter verification code
      setTimeout( () => dispatch("showVerify"), 1);
    }
  }
}


</script>